import firebase from 'firebase/app'
import config from '../services/firebaseConfig'
import authService from '../services/authenticationService'
import groupRepository from '../repositories/GroupRepository'
import Constants from '../Constants'

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

const groupService = {
  async isGroupMember (groupId) {
    const currentUser = authService.getCurrentUser()
    const membershipStatus = await groupRepository.getGroupMembershipStatus(groupId, currentUser.uid)
    return membershipStatus != null
  },

  async getMemberRequestStatus (groupId) {
    const currentUser = authService.getCurrentUser()
    const memberRequestStatus = await groupRepository.getMemberRequestStatus(groupId, currentUser.uid)
    if (memberRequestStatus == null) {
      return Constants.MemberRequestStatus.NOT_FOUND
    } else if (memberRequestStatus === 0) {
      return Constants.MemberRequestStatus.REJECTED
    } else {
      return Constants.MemberRequestStatus.PENDING
    }
  },

  async joinGroup (groupId) {
    const currentUser = authService.getCurrentUser()
    return groupRepository.saveUserToMemberRequests(groupId, currentUser.uid)
  }
}

export default groupService



// WEBPACK FOOTER //
// ./src/services/groupService.js